var generateStyle = function generateStyle(componentTheme) {
  var borderBottom = "solid 0.0625rem ".concat(componentTheme.colorGray);
  return {
    tableContainer: {
      width: 'calc(25% + 350px)',
      maxWidth: '100%',
      '& table': {
        borderCollapse: 'separate',
        borderSpacing: '0 1px',
        '& thead tr': {
          '& th, & td': {
            borderBottom: borderBottom
          }
        },
        '& tbody tr': {
          '& th, & td': {
            width: '33.33%',
            borderBottom: borderBottom
          },
          '& th': {
            fontWeight: 400
          }
        }
      }
    },
    textContainer: {
      height: 'calc(100% - 4px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    firstTextContainer: {
      padding: componentTheme.cellPadding
    }
  };
};
export default generateStyle;